import { gaEvent } from 'src/utils'

/**
 * [TARGET]: Ao enviar um formulário de cartão de crédito, caso exiba o toast de erro vamos emitir um evento.
 *
 * [CONTEXTO]: Na última etapa do link de pagamento, o usuário pode enviar o formulário e ter preenchido alguma informação inválida, caso isso ocorra vamos emitir um evento.
 *
 * [REGRAS]: n/a
 *
 */
export const errorToastEvent = (error: string) => {
  const event = {
    event: 'event',
    'event-category': `pagamentos-sellout:cartao-de-credito`,
    'event-action': 'toast',
    'event-label': error,
  }

  gaEvent(event)
}
